<app-unauthorized-layout>
  <div class="login-container reset-password-container">
    <app-auth-left-panel  [imageSrc]="'assets/images/airport.png'"
    imageAlt="Airport" additionalClass="reset-bg" class="login-image"></app-auth-left-panel>

    <div class="login-form-section">
    <img src="assets/images/logo.png" alt="Civil Aviation Authority" class="login-logo" />

    <div class="reset-password-card">
      <!-- Header -->
      <div class="reset-password-header">
        <h2>{{ 'resetPassword.title' | translate }}</h2>
        <p>{{ 'resetPassword.subtitle' | translate }}</p>
      </div>

      <!-- Token Validation Loading -->
      @if (isValidatingToken) {
        <div class="loading-state">
          <div class="spinner"></div>
          <p>{{ 'resetPassword.validatingToken' | translate }}</p>
        </div>
      }

      <!-- Token Error States -->
      @if (!isValidatingToken && !isTokenValid) {
        <div class="token-error">
          <div class="alert alert-danger">
            <div class="alert-content">
              <i class="bi bi-exclamation-triangle m-2 mx-4"></i>
              <div>
                <h4>{{ 'resetPassword.invalidTokenTitle' | translate }}</h4>
                <p>{{ tokenMessage || ('resetPassword.invalidToken' | translate) }}</p>
              </div>
            </div>
          </div>
        </div>
      }

      <!-- Form (Only show if token is valid) -->
      @if (!isValidatingToken && isTokenValid) {
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
          <!-- Success Message -->
          @if (successMessage) {
            <div class="alert alert-success">
              <div class="alert-content">
                <i class="bi bi-check-circle m-2"></i>
                <p>{{ successMessage }}</p>
              </div>
            </div>
          }
          <!-- Error Message -->
          @if (errorMessage) {
            <div class="alert alert-danger">
              <div class="alert-content">
                <i class="bi bi-exclamation-triangle m-2"></i>
                <p>{{ errorMessage }}</p>
              </div>
            </div>
          }
          <!-- Email Field -->
          <div class="form-group">
            <label for="email">{{ 'resetPassword.email' | translate }}</label>
            <input id="email" type="email" formControlName="email" class="form-control" placeholder="name@example.com"
              required>
              @if (getFieldError('email')) {
                <small class="form-text text-danger">
                  {{ getFieldError('email') }}
                </small>
              }
            </div>
            <!-- New Password Field -->
            <div class="form-group">
              <label for="newPassword">{{ 'resetPassword.newPassword' | translate }}</label>
              <input
                id="newPassword"
                type="password"
                formControlName="newPassword"
                class="form-control"
                placeholder="••••••••"
                (keyup)="form.get('newPassword')?.markAsTouched()"
                required>
                <small class="form-text text-muted">
                  {{ 'resetPassword.passwordRequirements' | translate }}
                </small>
                @if (getFieldError('newPassword')) {
                  <small class="form-text text-danger">
                    {{ getFieldError('newPassword') }}
                  </small>
                }
                <!-- Password Strength Indicator -->
                @if (form.get('newPassword')?.touched && form.get('newPassword')?.value) {
                  <div class="mt-2">
                    <small class="d-block mb-1 fw-semibold">{{ 'register.passwordStrength' | translate }}</small>
                    <div class="password-strength-checklist">
                      <div class="strength-item" [class.valid]="passwordStrength.hasNumber">
                        <i [ngClass]="passwordStrength.hasNumber ? 'bi bi-check-circle-fill text-success' : 'bi bi-circle text-muted'"></i>
                        <span>{{ 'register.containsNumber' | translate }}</span>
                      </div>
                      <div class="strength-item" [class.valid]="passwordStrength.hasLetter">
                        <i [ngClass]="passwordStrength.hasLetter ? 'bi bi-check-circle-fill text-success' : 'bi bi-circle text-muted'"></i>
                        <span>{{ 'register.containsLetter' | translate }}</span>
                      </div>
                      <div class="strength-item" [class.valid]="passwordStrength.hasSpecial">
                        <i [ngClass]="passwordStrength.hasSpecial ? 'bi bi-check-circle-fill text-success' : 'bi bi-circle text-muted'"></i>
                        <span>{{ 'register.containsSpecial' | translate }}</span>
                      </div>
                    </div>
                  </div>
                }
              </div>
              <!-- Confirm Password Field -->
              <div class="form-group">
                <label for="confirmPassword">{{ 'resetPassword.confirmPassword' | translate }}</label>
                <input id="confirmPassword" type="password" formControlName="confirmPassword" class="form-control"
                  placeholder="••••••••" required>
                  @if (getConfirmPasswordError()) {
                    <small class="form-text text-danger">
                      {{ getConfirmPasswordError() }}
                    </small>
                  }
                </div>
                <!-- Submit Button -->
                <button type="submit" class="btn btn-primary btn-block" [disabled]="form.invalid || isLoading"
                  [class.loading]="isLoading">
                  @if (!isLoading) {
                    <span>{{ 'resetPassword.resetButton' | translate }}</span>
                  }
                  @if (isLoading) {
                    <span>
                      <span class="spinner-border spinner-border-sm"></span>
                      {{ 'common.processing' | translate }}
                    </span>
                  }
                </button>
              </form>
            }

            <!-- Footer Links -->
            @if (!isValidatingToken) {
              <div class="reset-password-footer">
                @if (isTokenValid) {
                  <p class="login-link">
                    {{ 'resetPassword.rememberPassword' | translate }}
                    <a href="/login">{{ 'resetPassword.backToLogin' | translate }}</a>
                  </p>
                }
                @if (!isTokenValid) {
                  <p class="login-link">
                    <a href="/forgot-password">{{ 'resetPassword.requestNewLink' | translate }}</a>
                  </p>
                }
              </div>
            }
        </div>
      </div>
         </div>
</app-unauthorized-layout>